import React from 'react';

const EMOJI = /(\p{Extended_Pictographic}️?)/u;

type AriaHiddenEmojiProps = {
    text: string;
};

/** Renders `text` with every emoji hidden from assistive tech, so "🔊 EN" is announced as "EN". */
export function AriaHiddenEmoji({ text }: AriaHiddenEmojiProps) {
    return (
        <>
            {text.split(EMOJI).map((part, index) =>
                // split() with a capture group puts the matched emoji at odd indices
                index % 2 === 1 ? (
                    <span
                        key={index}
                        aria-hidden="true">
                        {part}
                    </span>
                ) : (
                    part
                )
            )}
        </>
    );
}
